// import React from 'react';
// // import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { Toaster } from 'react-hot-toast';
// import { AuthProvider, useAuth } from './context/AuthContext';
// import { ThemeProvider } from './context/ThemeContext';
// import ThemeSwitcher from './components/ThemeSwitcher';
// import Login from './pages/Login';
// import UserDashboard from './pages/UserDashboard';
// import AdminDashboard from './pages/AdminDashboard';
// import './App.css';

// function Guard({ children, adminOnly=false }) {
//   const { user, loading } = useAuth();
//   if (loading) return <div className="full-center"><div className="spinner"/></div>;
//   if (!user) return <Navigate to="/login" replace/>;
//   if (adminOnly && user.role!=='admin') return <Navigate to="/dashboard" replace/>;
//   return children;
// }

// function Home() {
//   const { user, loading } = useAuth();
//   if (loading) return null;
//   if (!user) return <Navigate to="/login" replace/>;
//   return <Navigate to={user.role==='admin'?'/admin':'/dashboard'} replace/>;
// }

// function Shell() {
//   const { user, logout } = useAuth();
//   return (
//     <div className="app">
//       {user && (
//         <header className="header">
//           <div className="header-inner">
//             <div className="logo">
//               <span className="logo-icon">🪪</span>
//               <span className="logo-text">ID<strong>Portal</strong></span>
//             </div>
//             <nav className="nav">
//               <ThemeSwitcher />
//               <div className="nav-user">
//                 {/* <span className={`badge ${user.role==='admin'?'badge-red':'badge-green'}`}>{user.role}</span> */}
//                 {/* <span className="nav-username">{user.username}</span> */}
//                 <button className="btn btn-outline btn-sm" onClick={logout}>Logout</button>
//               </div>
//             </nav>
//           </div>
//         </header>
//       )}
//       <main className={user ? "main" : ""}>
//         <Routes>
//           <Route path="/login"     element={<Login/>}/>
//           <Route path="/dashboard" element={<Guard><UserDashboard/></Guard>}/>
//           <Route path="/admin"     element={<Guard adminOnly><AdminDashboard/></Guard>}/>
//           <Route path="*"          element={<Home/>}/>
//         </Routes>
//       </main>
//       {user && <footer className="footer"><p>ID Profile Portal &copy; {new Date().getFullYear()}</p></footer>}
//     </div>
//   );
// }

// export default function App() {
//   return (
//     <ThemeProvider>
//       <AuthProvider>
//         <Router>
//           <Toaster position="top-right" toastOptions={{duration:4000,style:{background:'var(--surface)',color:'var(--text)',border:'1px solid var(--border)'}}}/>
//           <Shell/>
//         </Router>
//       </AuthProvider>
//     </ThemeProvider>
//   );
// }

import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ThemeSwitcher from './components/ThemeSwitcher';
import Login from './pages/Login';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';
import LandingPageCafeStyle from './pages/LandingPageCafeStyle';
import './App.css';

function Guard({ children, adminOnly=false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="full-center"><div className="spinner"/></div>;
  if (!user) return <Navigate to="/login" replace/>;
  if (adminOnly && user.role!=='admin') return <Navigate to="/dashboard" replace/>;
  return children;
}

// Remove Home component

function Shell() {
  const { user, logout } = useAuth();
  // We only render header/footer if user is authenticated (for dashboard/admin)
  // For landing page (user null), we don't render header/footer, and LandingPage has its own.
  return (
    <div className="app">
      {user && (
        <header className="header">
          <div className="header-inner">
            <div className="logo">
              <span className="logo-icon">🪪</span>
              <span className="logo-text">ID<strong>Portal</strong></span>
            </div>
            <nav className="nav">
              <ThemeSwitcher />
              <div className="nav-user">
                <button className="btn btn-outline btn-sm" onClick={logout}>Logout</button>
              </div>
            </nav>
          </div>
        </header>
      )}
      <main className={user ? "main" : ""}>
        <Routes>
          <Route path="/" element={<LandingPageCafeStyle />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Guard><UserDashboard/></Guard>} />
          <Route path="/admin" element={<Guard adminOnly><AdminDashboard/></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {user && <footer className="footer"><p>ID Profile Portal &copy; {new Date().getFullYear()}</p></footer>}
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Toaster position="top-right" toastOptions={{duration:4000,style:{background:'var(--surface)',color:'var(--text)',border:'1px solid var(--border)'}}}/>
          <Shell/>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}